
define(
    'jsx!components/widgets/toggle',[
        "jquery",
        "underscore",
        "backbone",
        "react"
    ],
    function($,_,Backbone,React){
        return React.createClass({
            displayName: "ToggleComponent",
            toggleStatus: function(){
                var self = this;
                this.props.toggleStatus();
            },
            render: function(){
                var label = this.props.label;
                var status = this.props.status;
                var classes = ["buncee-switch",(status ? "on" : "off")];
                if(this.props.classes){
                    classes.push(this.props.classes);
                }
                var text = status ? "ON" : "OFF";
                return (
                    React.createElement("div", {style: {"padding":"5px 0"}, className: "switch-item", onClick: this.toggleStatus}, 
                        React.createElement("span", {className: "switch-text"}, label), React.createElement("div", {className: classes.join(' ')}, React.createElement("div", {className: "buncee-switch-button"}), React.createElement("div", {className: "buncee-switch-text"}, text))
                    )
                )
            }
        });
    }
);
